<template lang="pug">
.link.gap-2.align-items-center(
  v-bind="$attrs"
  :class="$attrs.class"
)
  | {{ props.text }}
  slot(name="icon")
</template>

<script setup lang="ts">
import { type FakeInteractiveProps } from './FakeInteractive.types';
import { fakeInteractiveDefaults } from './FakeInteractive.defaults';

const props = withDefaults(
  defineProps<FakeInteractiveProps>(),
  fakeInteractiveDefaults,
);
</script>
